// src/event.ts
function bindAll(fns, context) {
  fns.forEach((fn) => {
    if (!context[fn]) {
      return;
    }
    context[fn] = context[fn].bind(context);
  });
}
var FrequencyController = class {
  constructor(duration = 16) {
    this.duration = 16;
    this.timestamp = (/* @__PURE__ */ new Date()).getTime();
    this.duration = duration;
  }
  run(callback) {
    const currentTime = (/* @__PURE__ */ new Date()).getTime();
    const timeCut = currentTime - this.timestamp;
    this.timestamp = currentTime;
    if (timeCut >= this.duration) {
      callback();
    }
  }
};
export {
  FrequencyController,
  bindAll
};
